export const HIGHLIGHT_TYPE_OPTIONS = [
  { value: 'community_post', label: 'Community post' },
  { value: 'listing', label: 'Marketplace listing' },
  { value: 'external_link', label: 'External link' },
  { value: 'no_cta', label: 'No CTA' },
];

export const MAX_HIGHLIGHT_CATEGORIES = 4;
export const MAX_HIGHLIGHT_SLIDES = 5;
export const MAX_HIGHLIGHT_CATEGORY_NAME_LENGTH = 20;
export const MAX_HIGHLIGHT_CAPTION_LENGTH = 200;
export const MAX_HIGHLIGHT_CTA_LABEL_LENGTH = 100;
export const HIGHLIGHT_TYPE_NO_CTA = 'no_cta';

export const getHighlightErrorMessage = error =>
  error?.error?.message || error?.message || 'Unable to update Highlights. Please try again.';

export const getMediaType = file => {
  if (file?.type?.startsWith('image/')) return 'image';
  if (file?.type?.startsWith('video/')) return 'video';
  return null;
};

export const isValidHighlightUrl = value => {
  if (!value) return false;
  if (value.startsWith('/') && !value.startsWith('//')) return true;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const validateHighlightForm = (values, { publishing = false } = {}) => {
  const errors = {};
  if (!values.referenceTitle?.trim()) errors.referenceTitle = 'Reference title is required.';
  if (!values.mediaUrl) {
    errors.media = publishing
      ? 'Media is required before publishing.'
      : 'Media is required before saving a draft.';
  }

  const isNoCta = values.highlightType === HIGHLIGHT_TYPE_NO_CTA;
  const hasLabel = !isNoCta && Boolean(values.ctaLabel?.trim());
  const hasUrl = !isNoCta && Boolean(values.ctaUrl?.trim());
  if (values.caption?.length > MAX_HIGHLIGHT_CAPTION_LENGTH) {
    errors.caption = `Caption must be ${MAX_HIGHLIGHT_CAPTION_LENGTH} characters or less.`;
  }
  if (!isNoCta && values.ctaLabel?.length > MAX_HIGHLIGHT_CTA_LABEL_LENGTH) {
    errors.ctaLabel = `CTA copy must be ${MAX_HIGHLIGHT_CTA_LABEL_LENGTH} characters or less.`;
  }
  if (hasLabel !== hasUrl) {
    errors.ctaUrl = 'CTA copy and CTA link must be provided together.';
  } else if (hasUrl && !isValidHighlightUrl(values.ctaUrl.trim())) {
    errors.ctaUrl = 'Enter a valid HTTP(S) URL or an app-relative link.';
  }
  return errors;
};

export const moveItem = (items, fromIndex, toIndex) => {
  if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0 || toIndex >= items.length) {
    return items;
  }
  const reordered = [...items];
  const [item] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, item);
  return reordered;
};
